import { ArrowRight } from 'lucide-react';
import { useModal } from '../../../../hooks/modalContext';
import { Icon } from '../../../../Icons/Icon';

const RedeemRewards = () => {
  const { setModal } = useModal();
  return (
    <div className='w-full'>
      <div className='space-y-4 w-full flex flex-col gap-4'>
        <span className='text-main text-base font-medium'>Ways to redeem</span>
        <div
          className='p-4 border border-[#DEE2EF] rounded-[20px]  hover:shadow-lg transition-shadow cursor-pointer bg-[linear-gradient(229deg,_#FFF_-13.57%,_#F2F4F9_113.63%)]'
          onClick={() => {
            setModal('redeem-points');
          }}
        >
          <div className='flex items-center justify-between w-full'>
            <Icon name='handCash' className='h-[44px] w-10 text-primary' strokeWidth={0.5} />
            <div className='flex flex-col gap-1'>
              <span className='text-main text-base font-semibold'>Redeem rent credit</span>
              <span className='text-[#8A92AB] text-sm font-medium max-w-[180px]'>
                Use in your next payment
              </span>
            </div>
            <ArrowRight className='text-main' size={24} />
          </div>
        </div>
        <div
          className='p-4 border border-[#DEE2EF] rounded-[20px]  hover:shadow-lg transition-shadow cursor-pointer bg-[linear-gradient(229deg,_#FFF_-13.57%,_#F2F4F9_113.63%)]'
          onClick={() =>
            setModal('all-gift-cards', {
              fromModal: 'rewards',
            })
          }
        >
          <div className='flex items-center justify-between w-full'>
            <Icon name='cardWallet' className='h-[44px] w-10 text-primary' strokeWidth={0.5} />
            <div className='flex flex-col gap-1'>
              <span className='text-main text-base font-semibold'>Gift cards</span>
              <span className='text-[#8A92AB] text-sm font-medium max-w-[180px]'>
                Browse rewards catalogue
              </span>
            </div>
            <ArrowRight className='text-main' size={24} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default RedeemRewards;
